import compare_func from 'compare-func'
import { AuditChangeSetV1, IAuditEventData } from '../../../api'

export const resolveEventData = <T extends IAuditEventData>(
  data: IAuditEventData | null | undefined,
  dataType: string,
) => {
  if (!data) return null

  const resolvedData = data.type === dataType ? (data as T) : null
  return resolvedData
}

export const resolveSnapshots = <TSnapshot extends IAuditEventData>(
  data: IAuditEventData | null | undefined,
  dataType: string,
) => {
  if (!data) {
    return [null, null]
  }

  const changeSet =
    data.type === nameof<AuditChangeSetV1>() &&
    (data as AuditChangeSetV1).dataType === dataType
      ? (data as AuditChangeSetV1)
      : undefined

  if (changeSet) {
    return [changeSet.original as TSnapshot, changeSet.updated as TSnapshot]
  }

  const snapshot = data.type === dataType && (data as TSnapshot)
  if (snapshot) {
    return [null, snapshot]
  }

  return [null, null]
}

export const zipSnapshots = (
  original: { [key: string]: string } | undefined,
  updated: { [key: string]: string } | undefined,
): { key: string; original: string; updated: string }[] => {
  var originalKeys = new Set(Object.keys(original ?? {}))
  var updatedKeys = new Set(Object.keys(updated ?? {}))

  var constantKeys = [...originalKeys].filter((x) => updatedKeys.has(x))
  var addedKeys = [...updatedKeys].filter((x) => !originalKeys.has(x))
  var removedKeys = [...originalKeys].filter((x) => !updatedKeys.has(x))

  var allKeys = [...constantKeys, ...addedKeys, ...removedKeys]
  var result = allKeys.sort(compare_func()).map((x) => ({
    key: x,
    original: (original as any)[x]?.toString(),
    updated: (updated as any)[x]?.toString(),
  }))

  return result
}
